var map = {
	"./ancar.png": "8693",
	"./banrisul.png": "a775",
	"./brahma.png": "10c0",
	"./brastemp.png": "1216",
	"./claro.png": "3ede",
	"./coca.png": "10bc",
	"./danone.png": "d970",
	"./iguatemi.png": "e6e5",
	"./melitta.png": "c7f2",
	"./michelin.png": "8e05",
	"./multiplan.png": "a581",
	"./pepsi.png": "6128",
	"./renner.png": "8136",
	"./santander.png": "bc59",
	"./sherwin.png": "f287",
	"./soifer.png": "bc44",
	"./ultra.png": "ae14",
	"./vivo.png": "ce0a",
	"./zaffari.png": "bfa1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c6d4";